import {
	EnvironmentProviders,
	Provider,
	signal,
	WritableSignal,
} from '@angular/core';
import { provideTaiga, TUI_DARK_MODE } from '@taiga-ui/core';

export const CONTEXT_TAIGA_OPTIONS = { mode: 'light' as const };

type TuiDarkModeSignal = WritableSignal<boolean> & { reset(): void };

/**
 * Taiga's default `TUI_DARK_MODE` signal follows the OS `prefers-color-scheme`
 * media query (and persisted preference), so `provideTaiga({ mode: 'light' })`
 * only sets the initial value and the theme still flips when the OS toggles
 * dark mode. We do not support dark mode, so replace the token with a signal
 * permanently locked to light mode that ignores OS and storage changes.
 */
export function provideForcedLightMode(): Provider {
	return {
		provide: TUI_DARK_MODE,
		useFactory: (): TuiDarkModeSignal => {
			const locked = signal(false) as TuiDarkModeSignal;
			const noop = (): void => undefined;

			locked.set = noop;
			locked.update = noop;
			locked.reset = noop;

			return locked;
		},
	};
}

export function provideContextTaiga(): Array<Provider | EnvironmentProviders> {
	return [...provideTaiga(CONTEXT_TAIGA_OPTIONS), provideForcedLightMode()];
}
